import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { getIsMobile, getIsLargeTablet, getWindowWidth } from '../../store/selectors/ui.selectors';

import SliderContainer, { Slide } from './Slider';
import ShoppingSpaceContainer, { productCollectionShape } from './ShoppingSpace';

class ShopBySpaces extends PureComponent {
  state = {
    currentSlide: 0,
  };

  constructor(props) {
    super(props);

    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.renderSpaces = this.renderSpaces.bind(this);
    this.isComponentVisible = this.isComponentVisible.bind(this);
  }

  handleSliderChange(currentSlide) {
    this.setState({ currentSlide });
  }

  isComponentVisible() {
    const {
      isTablet,
      isMobile,
      visibilities,
      windowWidth,
    } = this.props;

    if (windowWidth === 0) {
      return false;
    }

    if (isMobile) {
      return !visibilities.includes('HiddenMobile');
    }
    if (isTablet) {
      return !visibilities.includes('HiddenTablet');
    }
    return !visibilities.includes('HiddenDesktop');
  }

  renderSpaces() {
    const {
      theme,
      collections,
      disableInfiniteSlider,
    } = this.props;
    const {
      currentSlide,
    } = this.state;

    const shouldRenderAffirm = this.isComponentVisible();

    return (
      <div className="shop-by-spaces__spaces-container">
        <SliderContainer
          slidesPerView={1}
          arrows={false}
          pagination={true}
          breakpoints={{
            1024: {
              slidesPerView: 1.5,
              arrows: true,
              pagination: false,
            },
          }}
          theme={theme || 'light'}
          disableInfinite={disableInfiniteSlider}
          onChange={this.handleSliderChange}
        >
          {collections.map((collection, i) => (
            <Slide key={i}>
              <div className="shop-by-spaces__space-wrapper">
                <ShoppingSpaceContainer
                  productCollection={collection}
                  isCurrent={i === currentSlide}
                  shouldRenderAffirm={shouldRenderAffirm}
                />
              </div>
            </Slide>
          ))}
        </SliderContainer>
      </div>
    );
  }

  render() {
    const {
      anchor,
      header,
      type,
    } = this.props;

    return (
      <section
        id={anchor || undefined}
        className={classNames('shop-by-spaces', type)}
      >
        {header && (
          <div className="shop-by-spaces__header">
            <h2>
              {header}
            </h2>
          </div>
        )}
        {this.renderSpaces()}
      </section>
    );
  }
}

ShopBySpaces.defaultProps = {
  header: '',
  collections: [],
  visibilities: [],
  type: 'ShopBySpaces',
};

ShopBySpaces.propTypes = {
  anchor: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  isTablet: PropTypes.bool.isRequired,
  header: PropTypes.string,
  collections: PropTypes.arrayOf(productCollectionShape),
  visibilities: PropTypes.arrayOf(PropTypes.string),
  windowWidth: PropTypes.number.isRequired,
  type: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  isTablet: getIsLargeTablet(state),
  windowWidth: getWindowWidth(state),
});

export default connect(mapStateToProps, null)(ShopBySpaces);
